import { FolderContent } from '@/api/generatedApi';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CircularProgress from '@mui/material/CircularProgress';
import { ContentMoveState } from './utils';

export const ContentIcon = ({ content, size = 20 }: { content: FolderContent; size?: number }) => {
  if (content.contentType === 'folder') {
    return <FolderIcon sx={{ fontSize: size, color: 'primary.main' }} />;
  }
  return <InsertDriveFileIcon sx={{ fontSize: size, color: 'text.secondary' }} />;
};

export const StatusIcon = ({ status }: { status: ContentMoveState['status'] }) => {
  switch (status) {
    case 'processing': {
      return <CircularProgress size={16} />;
    }
    case 'success': {
      return <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />;
    }
    case 'error': {
      return <ErrorIcon sx={{ fontSize: 16, color: 'error.main' }} />;
    }
    default: {
      return;
    }
  }
};
